const my_profile = {
  viewMyClubSeacretProfile: "私のClubSecretプロフィールを見る", // translated
  viewMoreDetails: "詳細を見る", // translated
  verifiedEmail: "確認済みメールアドレス", // translated
  unverifiedEmail: "未確認のメール", // translated
  pointsOut: "指摘している", // translated
  pointsIn: "ポイントイン", // translated
  balance: "バランス", // translated
  pointsHistoryTable: "ポイント履歴テーブル", // translated
  topUp: "補充する", // translated
};


export default my_profile;
